import { EmailInbox } from './EmailInbox';

export default function IncomingEmails() {
  return (<EmailInbox inboxType="incoming"/>)
}
